import { LoadingSpinner, Modal } from '@employ-engage/common-components';
import { FormType } from '@employ-engage/data';
import DuplicateFormForm from '../duplicate-form-form/duplicate-form-form';
import { useTranslation } from 'react-i18next';

export interface DuplicateFormModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  formSelectedForDuplication?: FormType;
  refetchForms: () => void;
}

export function DuplicateFormModal({
  open,
  setOpen,
  formSelectedForDuplication,
  refetchForms,
}: DuplicateFormModalProps) {
  const { t } = useTranslation(['common']);
  return (
    <Modal open={open} setOpen={setOpen}>
      <div>
        <div className="flex flex-col items-center justify-center">
          <h1 className="text-3xl font-bold leading-9 text-gray-900">
            {t('Duplicate Form')}
          </h1>
          {formSelectedForDuplication ? (
            <DuplicateFormForm
              onClose={() => {
                setOpen(false);
                refetchForms();
              }}
              formSelectedForDuplication={formSelectedForDuplication}
            />
          ) : (
            <LoadingSpinner spinnerId="duplicate-survey-modal-loading" />
          )}
        </div>
      </div>
    </Modal>
  );
}

export default DuplicateFormModal;
